require('./brokerMiFID2Disclaimer.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const moment = require('moment');

// @utils
const { formatText, FormattedText } = require('core/i18n').i18n;
const { buildFormattedDate } = require('utilities/dateHelper');
const { conditionalValueOrHyphen } = require('utilities/valueHelper');
const { recordLinkV2 } = require("utilities/tagging");
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKInput } = require('commonsComponents/OKInput');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const BrokerMiFID2DisclaimerForAltFunds = require('mifid/components/brokerMiFID2DisclaimerForAltFunds/brokerMiFID2DisclaimerForAltFunds');

// @actions
const BrokerConvenienceMiFIDTestStepOmitTestAction = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStepOmitTest');
const BrokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');

// @constants
const {
    DATE_FORMAT_COMPLETE,
    DATE_FORMAT_SLASHED_ES,
    BROKER_CONVENIENCE_MIFID_WARRANT,
} = require('constants/index');

// @utilities
const { buildTestScoreInfo } = require("mifid/utilities/mifidTestTextHelper");

class BrokerMiFID2Disclaimer extends React.Component {
    constructor(props) {
        super(props);
        this.state =  {
            isDisabled: this.props.immBrokerConvenienceMiFIDTest.get('repeatSentence') && !__CONTACT_CENTER__
        }
        this.handleTranscribedPhraseChange = this.handleTranscribedPhraseChange.bind(this);
    }
    
    componentDidMount() {
        const { immBrokerConvenienceMiFIDTest, isIntermediateScreen, onStartConvenienceMiFIDTest } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['test', 'testToEvaluate', 'tipoTest'])
        if (isPrivateEquityTest(testToEvaluateId) && isIntermediateScreen) {
            onStartConvenienceMiFIDTest();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.immBrokerConvenienceMiFIDTest.get('omitTestCanContinue')) {
            nextProps.onContinueOperation();
        }
    }

    buildConcentrationDisclaimer() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const immConcentrationDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'concentrationDisclaimers']);

        if (!immConcentrationDisclaimers.isEmpty()) {
            const disclaimers = immConcentrationDisclaimers.map(immDisclaimer => {
                return (
                    <p key={immDisclaimer.get('id')}>
                        {immDisclaimer.get('description')}
                    </p>
                );
            });

            return (
                <div className="broker-mifid2-disclaimer">
                    <h2 className="broker-mifid2-disclaimer__title">
                        <FormattedText value="brokerMiFIDDisclaimerView-concentrationNotice" />
                    </h2>
                    {disclaimers}
                </div>
            );
        }
    }

    buildTestScoreInfo(reason) {
        const testScoreText = buildTestScoreInfo(reason);
        return (
            <React.Fragment>
                <p className="broker-mifid2-disclaimer__test-score-title">
                    <FormattedText value="brokerMiFIDDisclaimerView-testScoreTitle" />
                </p>
                <p className="broker-mifid2-disclaimer__test-score-description">
                    {testScoreText}
                </p>
            </React.Fragment>
        )
    }

    buildTestExecutionDateTime(executionDateFormatted) {
        return (
            <p className="broker-mifid2-disclaimer__test-execution-datetime">
                <FormattedText
                    value="brokerMiFIDDisclaimerView-dateAndTimeOfCompletion"
                    injectedStrings={[executionDateFormatted]}
                />
            </p>
        )
    }

    buildDisclaimer() {

        const { immBrokerConvenienceMiFIDTest } = this.props;
        const disclaimerText = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'primaryDisclaimer']);
        const disclaimerECFour = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
        const listNoShowDisclaimer = {
            EC4: 'EC4',
            EC2: 'EC2',
            EC1: 'EC1',
            EC3: 'EC3'
        }
        const validateDisclaimer = listNoShowDisclaimer[disclaimerECFour.getIn([0, 'id'])] !== undefined
        if(!!disclaimerText && !validateDisclaimer) {
            return(
                <div className="broker-mifid2-disclaimer__primary-disclaimer">
                    {disclaimerText}
                </div>
            );
        }
    }

    buildConvenienceEvaluationDisclaimer() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const isFirstTimePerformingTest = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'firstTimePerformingTest']);
        const lastExecutionDate = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'lastExecutionDate']);

        const executionDate = moment(lastExecutionDate, DATE_FORMAT_SLASHED_ES);
        const executionDateFormatted = conditionalValueOrHyphen(
            executionDate.isValid(),
            buildFormattedDate(executionDate, DATE_FORMAT_COMPLETE)
        );

        let testScoreInfo, testExecutionDateTime;

        let content =  (
            <div className='broker-mifid2-disclaimer__test-empty-section' />
        );

        if (!isFirstTimePerformingTest) {
            const reason = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'reason']);
            testScoreInfo = this.buildTestScoreInfo(reason);
            testExecutionDateTime = this.buildTestExecutionDateTime(executionDateFormatted);

            content = (
                <div className="broker-mifid2-disclaimer__test-section">
                    {testScoreInfo}
                    {testExecutionDateTime}
                </div>
            )
        }

        return content;
    }

    buildFooter() {
        const { isDisabled } = this.state;
        const hasPhraseToTranscribe = this.props.immBrokerConvenienceMiFIDTest.get('repeatSentence');
        const continueFuntion = this.props.immBrokerConvenienceMiFIDTest.get('repeatSentence') ? this.props.onValidateTranscription : this.props.onContinueOperation;
        const continueLabel =
            hasPhraseToTranscribe && !__CONTACT_CENTER__ ?
                'brokerMiFIDDisclaimerView-sendAndContinue' :
                'brokerMiFIDDisclaimerView-continue';
        return (
            <div className="broker-mifid2-disclaimer__footer">
                <div className="row">
                    <div className="col-xs-6">
                        <OKButton modifier="link-ghost" onClick={this.props.onCancel}>
                            <FormattedText value="brokerMiFIDDisclaimerView-cancel" />
                        </OKButton>
                    </div>
                    <div className="col-xs-6 text-right">
                        <OKButton disabled={isDisabled} onClick={continueFuntion}>
                            <FormattedText value={continueLabel} />
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    buildObjectiveTargetDisclaimer() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const immObjectiveTargetDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'objectiveTargetDisclaimers']);

        if (!immObjectiveTargetDisclaimers.isEmpty()) {
            const disclaimers = immObjectiveTargetDisclaimers.map(immDisclaimer => {
                return (
                    <p key={immDisclaimer.get('id')}>
                        {immDisclaimer.get('description')}
                    </p>
                );
            });

            return (
                <div className="broker-mifid2-disclaimer__section">
                    <h2 className="broker-mifid2-disclaimer__title">
                        <FormattedText value="brokerMiFIDDisclaimerView-audienceTarget" />
                    </h2>
                    {disclaimers}
                    {this.buildConcentrationDisclaimer()}
                </div>
            );
        }
    }

    buildWarrantDisclaimer() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const productType = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'productType']);
        const warrantDisclaimer = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'warrantDisclaimer']);
        if(__CONTACT_CENTER__ && productType === BROKER_CONVENIENCE_MIFID_WARRANT && !!warrantDisclaimer){
            return (
                <div className="broker-mifid2-disclaimer__bottom-section">
                    <h2 className="broker-mifid2-disclaimer__title">
                        <FormattedText value="brokerMiFIDDisclaimerView-warrantDisclaimerTitle" />
                    </h2>
                    {warrantDisclaimer}
                </div>
            );
        }
    }

    buildTitleConvenienceTest() {
        return (
            <div className="broker-mifid2-disclaimer__title-container">
                <h2 className="broker-mifid2-disclaimer__title">
                    <FormattedText value="brokerMiFIDDisclaimerView-convenienceEvaluation" />
                </h2>
            </div>
        )
    }

    buildDisclamerResolve() {
        const { immBrokerConvenienceMiFIDTest, isIntermediateScreen } = this.props;
        if ((immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'reason']) === 1 && isIntermediateScreen) || immBrokerConvenienceMiFIDTest.get('repeatSentence')) {
            return (
                <div>
                    <h2 className="broker-mifid2-disclaimer__title">
                        <FormattedText value="brokerMiFIDDisclaimerView-transcriptionTitle" />
                    </h2>
                    <p>
                        <FormattedText value="brokerMiFIDDisclaimerView-transcriptionDisclaimer" />
                    </p>
                </div>
            )
        }
    }

    buildContinuePhraseCC() {
        const { immBrokerConvenienceMiFIDTest  } = this.props;
        if(immBrokerConvenienceMiFIDTest.get('repeatSentence')) {
            const disclaimerWithPhrase = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
                .find(disclaimer => !!disclaimer.get('phrase'))
            const phraseDisclaimerID = !!disclaimerWithPhrase && disclaimerWithPhrase.get('id')
            const isCryptoProduct = !!phraseDisclaimerID ? phraseDisclaimerID.includes('EC') : false
            const cryptoDescription = (
                <p>
                    {disclaimerWithPhrase.get('description')}
                </p>
            );
            const description = isCryptoProduct
                ? cryptoDescription
                : formatText(
                      "brokerMiFIDDisclaimerView-CCPhraseSectionDescription"
                  );
            const phrase = (
                <span>"{ immBrokerConvenienceMiFIDTest.get('repeatSentence')}"</span>
            )
            const descriptionRepeatSentence = immBrokerConvenienceMiFIDTest.get('descriptionRepeatSentence');
            return (
                <div>
                    <div className="broker-mifid2-disclaimer__section-cc-phrase">
                        <div className="broker-mifid2-disclaimer__section-cc-description">
                            {description}
                        </div>
                        <BlockInfo>
                            <p className="broker-mifid2-disclaimer__phrase-disclaimer-content">
                                {descriptionRepeatSentence}
                            </p>
                            <p className="broker-mifid2-disclaimer__phrase-disclaimer-content">
                                {phrase}
                            </p>
                        </BlockInfo>
                    </div>
                </div>
            );
        }
    }

    buildTranscribePhraseInput() {
        const { immBrokerConvenienceMiFIDTest,  } = this.props;
        if (!__CONTACT_CENTER__ && immBrokerConvenienceMiFIDTest.get('repeatSentence')) {
            const transcription = immBrokerConvenienceMiFIDTest.get('omitTestTrascriptionText');
            const omitTestInvalidText = immBrokerConvenienceMiFIDTest.get('omitTestInvalidText');
            const description = immBrokerConvenienceMiFIDTest.get('descriptionRepeatSentence');
            const phrase = immBrokerConvenienceMiFIDTest.get('repeatSentence')
            return (
                <div className="broker-mifid2-disclaimer__section">
                    <p>
                        {description}
                        <strong>"{phrase}"</strong>
                    </p>
                    <OKInput
                        value={transcription}
                        errorState={omitTestInvalidText}
                        errorMessage={formatText('broker-convenienceMifidTestTranscriptionError')}
                        onChange={this.handleTranscribedPhraseChange}
                        autoComplete="off"
                        placeholder={formatText('broker-convenienceMifidTestTranscriptionPlaceholder')}
                    />
                </div>
            );
        }
    }

    buildCryptoWarning(){
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const cryptoDisclaimer = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'cryptoDisclaimer']).toJS();

        if (cryptoDisclaimer.length === 0) return;

        const criptoDisclaimerDescription = cryptoDisclaimer.map(
            (disclaimer) => (
                <p key={disclaimer.id}>
                    {disclaimer.description}
                </p>
            )
        );

        return (
            <div>
                <h2 className="broker-mifid2-disclaimer__title">
                    <FormattedText value="brokerMiFIDDisclaimerView-criptoDisclaimerTitle" />
                </h2>
                {criptoDisclaimerDescription}
            </div>
        );
    }

    eventTag(actionEvent, labelEvent) {
        const eventCategory = formatText('brokerMiFIDDisclaimerView-eventCategory');

        recordLinkV2({
            categoriaEvento: eventCategory,
            accionEvento: actionEvent,
            etiquetaEvento: labelEvent,
        })
    }

    buildRetakeTestLink() {
        const { immBrokerConvenienceMiFIDTest, isIntermediateScreen } = this.props;
        const labelEvent = formatText('brokerMiFIDDisclaimerView-labelEventLink')
        const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
        const disclaimerD0 = immDisclaimers.find(immDisclaimer => immDisclaimer.get('id')==='D0');
        const disclaimerTM0 = immDisclaimers.find(immDisclaimer => immDisclaimer.get('id')==='TM0');
        const simpleProduct = !!disclaimerD0 && !!disclaimerTM0;

        if (!simpleProduct && isIntermediateScreen){
            const link = (
                <OKLink onClick={() => {
                    this.props.onStartConvenienceMiFIDTest();
                    this.eventTag('clickLink',labelEvent)
                }} modifier="emphasize">
                    <FormattedText value="brokerMiFIDDisclaimerView-linkSectionLinkLabel" />
                </OKLink>
            );

            return (
                <p className="broker-mifid2-disclaimer__link-section">
                    <FormattedTextWithComponents
                        value="brokerMiFIDDisclaimerView-linkSectionText"
                        injectedComponents={[
                            link
                        ]}
                    />
                </p>
            );
        }
        return null;
    }

    handleTranscribedPhraseChange(e) {
        this.setState({
            isDisabled: false
        });
        const labelEvent = formatText('brokerMiFIDDisclaimerView-labelEventInput')
        this.props.onChangeTranscription(e.target.value);
        this.eventTag('clickTextBox',labelEvent)
    }

    render() {
        const { immBrokerConvenienceMiFIDTest, onContinueOperation, onCancel, addPrivateEquityDisclaimers, isIntermediateScreen } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['test', 'testToEvaluate', 'tipoTest'])
        if(isPrivateEquityTest(testToEvaluateId)) {
            return (
                <BrokerMiFID2DisclaimerForAltFunds
                    isIntermediateScreen={isIntermediateScreen}
                    onContinueOperation={onContinueOperation}
                    immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                    onCancel={onCancel}
                    addPrivateEquityDisclaimers={addPrivateEquityDisclaimers}
                />
            );
        }
        let phraseSection;
        if (__CONTACT_CENTER__) {
            phraseSection = this.buildContinuePhraseCC();
        } else {
            phraseSection = this.buildTranscribePhraseInput();
        }

        return (
            <div className="broker-mifid2-disclaimer">
                <OKSectionBox>
                    {this.buildTitleConvenienceTest()}
                    {this.buildDisclaimer()}
                    {this.buildConvenienceEvaluationDisclaimer()}
                    {this.buildDisclamerResolve()}
                    {phraseSection}
                    {this.buildCryptoWarning()}
                    {this.buildObjectiveTargetDisclaimer()}
                    {this.buildWarrantDisclaimer()}
                    {this.buildRetakeTestLink()}
                    {this.buildFooter()}
                </OKSectionBox>
            </div>
        );
    }
}

BrokerMiFID2Disclaimer.propTypes = {
    onContinueOperation: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    onChangeTranscription: PropTypes.func.isRequired,
    addPrivateEquityDisclaimers: PropTypes.func.isRequired,
    onValidateTranscription: PropTypes.func.isRequired,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    isIntermediateScreen: PropTypes.bool,
};

BrokerMiFID2Disclaimer.defaultProps = {
    isIntermediateScreen: false
};

module.exports.BrokerMiFID2Disclaimer = connect(
    (state) => ({ immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest }),
    {
        onValidateTranscription: BrokerConvenienceMiFIDTestStepOmitTestAction.validateTranscription,
        onChangeTranscription: BrokerConvenienceMiFIDTestStepOmitTestAction.changeTranscription,
        addPrivateEquityDisclaimers: BrokerConvenienceMiFIDTestActions.addPrivateEquityDisclaimers,
    }
)(BrokerMiFID2Disclaimer);
